module.exports = __webpack_public_path__ + "images/banner_01.jpg?d74cd5cf37d6c22f80f145dabaaf60db";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_01.jpg
// module id = 215
// module chunks = 1